<app-header [breadcrumbs]="['Providers', 'Add provider']" mainHeading="Add provider"
            [links]="['/providers', '/add-provider']" />


<main class="add-new-shell">
    <cll-horizontal-stepper [currentStepId]="currentStepId()"
                            (currentStepIdChange)="currentStepId.set($any($event))"
                            colour="secondary"
                            [items]="steps()"
                            [showDescription]="false" />
    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.provider">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">person</cll-icon>
            <cll-card-title>Provider Details</cll-card-title>
        </cll-card-header>

        <div class="add-new-row-container">
            <div>
                <cll-form-field label="Provider reference" class="w-full">
                    <input cllFormInput [formControl]="providerDetailsFormGroup.controls.reference" type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Provider name" class="w-full">
                    <input cllFormInput [formControl]="providerDetailsFormGroup.controls.name" type="text">
                </cll-form-field>
            </div>
        </div>
    </cll-card>

    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.contact">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">person</cll-icon>
            <cll-card-title>Contact details</cll-card-title>
        </cll-card-header>

        <div class="add-new-row-container">
            <div>
                <cll-form-field label="Email address" class="w-full">
                    <input cllFormInput type="email" [formControl]="providerDetailsFormGroup.controls.email">
                </cll-form-field>
            </div>
            <hr class="add-new-divider-small">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">phone_in_talk</cll-icon>
                <cll-card-title>Phone number(s)</cll-card-title>
            </cll-card-header>
            <form [formGroup]="contactNumbersForm">
                <div formArrayName="contactNumbers">
                    <div *ngFor="let group of contactNumbersFormArray.controls; let i = index" [formGroupName]="i">
                        <div class="contact-numbers-container">
                            <div>
                                <cll-form-field label="Type" class="w-full">
                                    <select formControlName="type" cllFormInput>
                                        <option value="mobile">Mobile</option>
                                        <option value="landline">Landline</option>
                                        <option value="work">Work</option>
                                        <option value="fax">Fax</option>
                                    </select>
                                </cll-form-field>
                            </div>
                            <div>
                                <cll-form-field label="Phone number" class="w-full">
                                    <input cllFormInput type="text" formControlName="number">
                                </cll-form-field>
                            </div>
                            <div>
                                <button cll-button class="delete-button" type="button"
                                        (click)="removeContactNumber(i)">
                                    <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <button cll-filled-button class="add-button" (click)="addContactNumber()">
                    <cll-icon cllButtonIcon>add</cll-icon>
                    Add
                </button>
            </form>
            <div class="contact-preference-container">
                <cll-form-field label="Contact Preferences" class="w-full">
                    <select cllFormInput>
                        <option value="mobile">Mobile</option>
                        <option value="landline">Landline</option>
                        <option value="work">Work</option>
                        <option value="fax">Fax</option>
                    </select>
                </cll-form-field>
            </div>
            <hr class="add-new-divider-small">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">home</cll-icon>
                <cll-card-title>Address</cll-card-title>
            </cll-card-header>
            <div class="grid-columns-2">
                <div>
                    <cll-form-field label="Address line 1" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.street_1" />
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="Address line 2" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.street_2" />
                    </cll-form-field>
                </div>
            </div>

            <div class="grid-columns-2">
                <div>
                    <cll-form-field label="Town/City" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.town" />
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="County" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.county" />
                    </cll-form-field>
                </div>
            </div>

            <div class="grid-columns-2">
                <div>
                    <cll-form-field label="Post code" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.post_code" />
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="Country" class="w-full">
                        <input cllFormInput type="text" [formControl]="addressFormGroup.controls.country" />
                    </cll-form-field>
                </div>
            </div>
            <div>
                <div>
                    <cll-form-field label="CQC Location ID" class="w-full">
                        <input cllFormInput type="text"
                               [formControl]="providerDetailsFormGroup.controls.cqc_location_id" />
                    </cll-form-field>
                </div>
            </div>
            <div>
                <div>
                    <cll-form-field label="Additional comments" class="w-full">
                        <input cllFormInput type="text"
                               [formControl]="addressFormGroup.controls.additional_comments" />
                    </cll-form-field>
                </div>
            </div>
        </div>
    </cll-card>

    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.regionAndZones">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">explore</cll-icon>
            <cll-card-title>Region/zone allocation</cll-card-title>
        </cll-card-header>
        <form [formGroup]="regionOptionsForm">
            <div formArrayName="regionOptions">
                <div *ngFor="let group of regionOptionsFormArray.controls; let i = index, let last = last"
                     [formGroupName]="i" class="add-new-row-container">
                    <div class="add-new-row-container">
                        @if (group.value.region?.id) {
                            <cll-form-field label="Region" class="small-input">
                                <input cllFormInput
                                       type="text"
                                       disabled="disabled"
                                       value="{{ group.value.region.name }}"
                                />
                            </cll-form-field>

                            @if (zoneDataSources[group.value.region.id]) {
                                <cll-form-field label="Zones" class="small-input">
                                    <cll-multi-select
                                        [options]="zoneDataSources[group.value.region.id]"
                                        formControlName="zones"
                                    />
                                    <cll-form-field-hint>
                                        Select one or multiple
                                    </cll-form-field-hint>
                                </cll-form-field>
                            }
                            @if (priorityDataSources[group.value.region.id]) {
                                <cll-form-field label="Priority" class="small-input">
                                    <cll-select
                                        [options]="priorityDataSources[group.value.region.id]"
                                        formControlName="priority"
                                    />
                                </cll-form-field>

                                <button cll-filled-button class="regions-add-button m-b-40" (click)="removeRegion(i)">
                                    <cll-icon cllButtonIcon type="outlined">delete</cll-icon>
                                    Remove
                                </button>
                            }
                        } @else {
                            <cll-form-field label="Region" class="small-input">
                                <cll-select
                                    [options]="searchableRegionDataSource"
                                    formControlName="region"
                                />
                            </cll-form-field>
                        }
                        @if (last) {
                            @if (group.value.region?.id) {
                                @if (i < ((data.allRegions$ | async)?.data ?? []).length - 1) {
                                    <span class="add-new-field-group-label">
                                Want to add another Region? Click the ‘Add’ button below:
                                    </span>
                                    <button cll-filled-button class="regions-add-button"
                                            (click)="addRegion()">
                                        <cll-icon cllButtonIcon type="outlined">add</cll-icon>
                                        Add
                                    </button>
                                }
                            }
                        }
                    </div>
                </div>
            </div>
        </form>
    </cll-card>

    <cll-card class="add-new-card" *ngIf="currentStepId() === Step.careOptions">
        <cll-card-header>
            <cll-icon cllCardIcon type="outlined">volunteer_activism</cll-icon>
            <cll-card-title>Care Options</cll-card-title>
        </cll-card-header>

        <form [formGroup]="careOptionsForm">
            <div formArrayName="careOptions">
                <div *ngFor="let group of careOptionsFormArray.controls; let i = index, let last = last"
                     [formGroupName]="i">
                     <hr *ngIf="i > 0" class="add-new-divider-small" />
                    <div class="add-new-row-container">
                        <div class="contact-numbers-container">
                            @if (group.value.care_type?.id) {
                                <cll-form-field label="Care Type" class="small-input">
                                    <input cllFormInput
                                           type="text"
                                           disabled="disabled"
                                           value="{{ group.value.care_type.name }}" />
                                </cll-form-field>

                                @if (careOptionDataSources[group.value.care_type.id]) {
                                    <cll-form-field label="Care Options" class="small-input">
                                        <cll-select
                                            [options]="careOptionDataSources[group.value.care_type.id]"
                                            formControlName="care_option"
                                        />
                                    </cll-form-field>
                                    <button cll-button class="delete-button" type="button"
                                        (click)="removeCareOption(i)">
                                        <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                    </button>
                                }
                            } @else {
                                <cll-form-field label="Care Type" class="small-input">
                                    <cll-select
                                        [options]="searchableCareTypeDataSource"
                                        formControlName="care_type"
                                    />
                                </cll-form-field>
                                <div>
                                </div>
                                @if (i !== 0) {
                                    <button cll-button class="delete-button" type="button"
                                    (click)="removeCareOption(i)">
                                    <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                </button>
                                }
                            }

                            @if (includePriceSelectedKeys.includes(i)) {
                                <div class="include-price-container">
                                    <div>
                                        <app-toggle 
                                        [checked]="careOptionsForm.value.careOptions?.[i]?.include_price || false"
                                        (toggled)="onIncludePriceToggle($event, i)" 
                                        label="This care option has ‘Include Price’ enabled. Do you want to enable a fee?" 
                                        />
                                    </div>

                                    @if (includePriceFlags[i]) {
                                        <cll-form-field label="Price" class="small-input">
                                            <input cllFormInput type="number" formControlName="price" />
                                            <cll-form-field-hint>
                                                Enter the price for this care option
                                            </cll-form-field-hint>
                                        </cll-form-field>
                                      }
                                </div>
                            }
                        </div>
                        @if (last) {
                            @if (group.value.care_type?.id) {
                                @if (i < ((data.allCareTypes$ | async)?.data ?? []).length - 1) {
                                    <span class="add-new-field-group-label add-span-margin">
                                        Want to add another Care Type? Click the ‘Add’ button below:
                                    </span>
                                    <button cll-filled-button class="regions-add-button"
                                            (click)="addCareOption()">
                                        <cll-icon cllButtonIcon type="outlined">add</cll-icon>
                                        Add
                                    </button>
                                }
                            }
                        }
                    </div>
                </div>
            </div>
        </form>
    </cll-card>

    <cll-card>
        <div class="add-new-footer-buttons-container">

            <button cll-button (click)="cancel()">
                Cancel
            </button>

            <button cll-button type="button" (click)="goToPreviousStep()" *ngIf="currentStepId() !== Step.provider">
                Back
            </button>

            <button cll-filled-button colour="secondary" type="button" (click)="goToNextStep()"
                    iconPosition="after" *ngIf="currentStepId() !== Step.careOptions">Next
                <cll-icon>chevron_right</cll-icon>
            </button>

            <button cll-filled-button colour="secondary" *ngIf="currentStepId() === Step.careOptions"
                    [disabled]="
                        careOptionsForm.invalid || false || providerDetailsFormGroup.invalid || contactNumbersForm.invalid || addressFormGroup.invalid || regionOptionsForm.invalid ||
                        regionOptionsFormArray.length === 0
                    "
                    (click)="createProvider()">
                Create provider
                <cll-icon>check</cll-icon>
            </button>
        </div>
    </cll-card>
</main>

